module.exports = __webpack_public_path__ + "static/img/testimony (59).9210c124.jpg";